// 16-05-2025
import { formatBase64 } from "../../pages/Utility/utilsFunctions";
import { getChargerById } from "../chargerAPI";
import { getImage } from "../imageAPI";

// get charger by chargerId
const handleGetChargerById = async (id) => {
  try {
    const data = await getChargerById(id);
    //   console.log("response chargerId: ", data);
    // const lasthb = response?.data?.lastHeartbeat;

    return data;
  } catch (err) {
    console.log("Error getting the chargersData: ", err.msg, id);
  }
};

//  to map the charger to the location
export const mapChargersToLocation = async (data) => {
  const locations = {};

  await Promise.all(
    data.map(async (charger) => {
      try {
        const res = await handleGetChargerById(charger);
        if (!res || !res.locationId) {
          console.warn(`Invalid response for charger ${charger}`, res);
          return;
        }

        if (!locations[res.locationId]) {
          locations[res.locationId] = [];
        }

        locations[res.locationId].push({"id": charger,"name":res?.name});
      } catch (err) {
        console.error("Error loading charger data for ID", charger, err);
      }
    })
  );

  // console.log("Mapped locations to chargers: ", locations);

  return locations;
};

